<template>
    <div class="col-md-12">
        <ckeditor :editor="editor" v-model="description" :config="editorConfig"></ckeditor>
        <input type="hidden" v-model="description" name="description">
    </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue';
export default {
    props: {
        old: {
            type: String,
            default: ''
        }
    },
    components: { ckeditor: CKEditor.component },
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    items: ['link']
                },
                link: {
                    decorators: {
                        isExternal: {
                            mode: 'manual',
                            label: 'Open in a new tab',
                            attributes: {
                                target: '_blank'
                            }
                        }
                    }
                },
                placeholder: 'Service description',
            },
            description: ''
        };
    },
    mounted() {
        if (this.old !== '') {
            this.description = this.old;
        }
    }
};
</script>

<style>
:root {
    --ck-z-default: 100;
    --ck-z-panel: calc( var(--ck-z-default) + 999 );
}
</style>
